import { ViewHeadline, ViewModule } from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ButtonToggle } from '../ButtonToggle';

const ViewToggleContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.field,
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  gap: 2,
  justifyContent: 'flex-end',
  padding: 2,
  zIndex: 2,
}));

export interface ViewToggleProps {
  view: 'List' | 'Grid';
  onViewChange: (view: 'List' | 'Grid') => void;
}

export const ViewToggle = ({ view, onViewChange }: ViewToggleProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ position: 'relative' }}>
      <ViewToggleContainer role="group" aria-label={t('components.view_toggle.label')}>
        <ButtonToggle
          aria-pressed={view === 'List'}
          title={t('components.view_toggle.list_view')}
          value="List"
          view={view === 'List'}
          onClick={() => onViewChange('List')}
        >
          <ViewHeadline />
        </ButtonToggle>
        <ButtonToggle
          aria-pressed={view === 'Grid'}
          title={t('components.view_toggle.grid_view')}
          value="Grid"
          view={view === 'Grid'}
          onClick={() => onViewChange('Grid')}
        >
          <ViewModule />
        </ButtonToggle>
      </ViewToggleContainer>
    </Box>
  );
};
